import { useRef } from 'react';
import { TicketFileDto } from '@sib/api';
import { Button, Card, Tooltip } from '@sib/ui';
import { handleExternalLink } from '@sib/utils';
import { DownloadIcon } from '@spendbrain/icons';

interface DocumentItemProps {
  file: TicketFileDto;
}

export const DocumentItem = ({ file }: DocumentItemProps) => {
  const fileNameRef = useRef<HTMLParagraphElement>(null);

  const isFileNameOverflowing = fileNameRef.current
    ? fileNameRef.current.offsetHeight < fileNameRef.current.scrollHeight ||
      fileNameRef.current.offsetWidth < fileNameRef.current.scrollWidth
    : false;

  return (
    <Card className="grid w-full gap-2 p-[14px]">
      <div className="flex w-full min-w-0 items-center justify-between gap-2 text-sm">
        <Tooltip
          TooltipTriggerProps={{ asChild: true }}
          TooltipContentProps={{
            className: 'max-w-[420px] wrap-break-word',
          }}
          content={isFileNameOverflowing && file.fileName}
        >
          <p
            ref={fileNameRef}
            className="min-w-0 flex-[1_1] truncate text-[#667080]"
          >
            {file.fileName}
          </p>
        </Tooltip>

        <a
          href={handleExternalLink(file.fileUrl)}
          target="_blank"
          rel="noopener noreferrer"
          download
        >
          <Button variant="ghost" type="button">
            <DownloadIcon className="text-primary size-5" />
          </Button>
        </a>
      </div>
    </Card>
  );
};
